import React from 'react';
import MasterLayout from '../../components/MasterLayout';

const Roles = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Name' },
    { key: 'description', label: 'Description' },
    { key: 'is_active', label: 'Status' },
  ];

  const formFields = [
    { name: 'code', label: 'Code', required: true, placeholder: 'ADMIN' },
    { name: 'name', label: 'Name', required: true, placeholder: 'Role Name' },
    { name: 'description', label: 'Description', type: 'textarea', fullWidth: true },
    { name: 'is_active', label: 'Status', type: 'boolean', defaultValue: true },
  ];

  return (
    <MasterLayout
      title="Roles"
      endpoint="roles"
      columns={columns}
      formFields={formFields}
      permissions={['ADMIN']}
      allowBulkUpload={false}
    />
  );
};

export default Roles;
